export const resolveTimerDuration = ({
	itemTimeLimit,
	itemTimeElapsed,
	totalTime,
}: {
	itemTimeLimit?: number;
	itemTimeElapsed?: number;
	totalTime: number;
}): number => {
	if (itemTimeLimit) {
		return Math.max(0, itemTimeLimit - (itemTimeElapsed ?? 0));
	}
	return totalTime;
};

export const calculateTotalTimeRemaining = ({
	isOlxSession,
	startTime,
	isBreakOngoing,
	totalTime,
	sessionTime,
	breakTimeTakenInSeconds,
}: {
	isOlxSession?: boolean;
	startTime?: string;
	isBreakOngoing?: boolean;
	totalTime: number;
	sessionTime?: number;
	breakTimeTakenInSeconds?: number;
}): number => {
	if (isOlxSession && startTime && !isBreakOngoing) {
		let elapsed = Math.floor(
			(Date.now() - new Date(startTime).getTime()) / 1000,
		);
		if (breakTimeTakenInSeconds) {
			elapsed -= breakTimeTakenInSeconds;
		}
		return Math.max(0, totalTime - elapsed);
	}
	return totalTime - (sessionTime || 0);
};
